export enum FieldTypeSchemas {
  Bool = 'Bool',
  Enum = 'Enum',
  Node = 'Node',
  Number = 'Number',
  String = 'String',
  Date = 'Date',
}

export interface BoolFieldType {
  type: FieldTypeSchemas.Bool;
  isRequired?: boolean;
  defaultValue?: boolean;
}

export interface EnumFieldType {
  type: FieldTypeSchemas.Enum;
  enumId: string;
  isRequired?: boolean;
  defaultValue?: number | string;
}

export interface NumberFieldType {
  type: FieldTypeSchemas.Number;
  isRequired?: boolean;
  defaultValue?: number;
}

export interface StringFieldType {
  type: FieldTypeSchemas.String;
  isRequired?: boolean;
  defaultValue?: string;
}

export interface DateFieldType {
  type: FieldTypeSchemas.Date;
  isRequired?: boolean;
  defaultValue?: string;
}

export type FieldTypeSchema =
  | BoolFieldType
  | EnumFieldType
  | NumberFieldType
  | StringFieldType
  | DateFieldType;
